import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { service } from "@ember/service";
import { task, timeout } from "ember-concurrency";
import ENV from "glesys-controlpanel/config/environment";
import { statusPageNotices } from "glesys-controlpanel/data/status-page/builders";

export default class extends Component {
  @service store;

  @tracked serviceInfo = [];

  constructor() {
    super(...arguments);
    this.fetchServiceInfo.perform();
  }

  willDestroy() {
    super.willDestroy(...arguments);
    this.fetchServiceInfo.cancelAll();
  }

  fetchServiceInfo = task(async () => {
    let { content } = await this.store.request(statusPageNotices());
    this.serviceInfo = content;
    if (ENV.environment !== "test") {
      await timeout(1000 * 60);
      this.fetchServiceInfo.perform();
    }
  });

  get maintenances() {
    return this.serviceInfo.notices
      ?.filter((notice) => notice.type === "planned")
      .map((maintenance) => {
        return {
          name: maintenance.subject,
          text: maintenance.latest_update.content,
          date: maintenance.begins_at,
          link: maintenance.url,
        };
      })
      .toSorted((a, b) => a.date.localeCompare(b.date));
  }

  get incidents() {
    return this.serviceInfo.notices
      ?.filter((notice) => notice.type === "unplanned")
      .map((incident) => {
        return {
          name: incident.subject,
          text: incident.latest_update.content,
          date: incident.updated_at,
          link: incident.url,
        };
      });
  }

  get hasActiveMaintenance() {
    return !!this.maintenances?.length;
  }

  get hasActiveIncidents() {
    return !!this.incidents?.length;
  }
}
